import { ImSpades } from "react-icons/im";
import { FaClover, FaDiamond } from "react-icons/fa6";
import { PiCardsFill } from "react-icons/pi";
import { BiLike } from "react-icons/bi";
import { HiOutlineChatBubbleLeftRight } from "react-icons/hi2";
import { BsThreeDotsVertical } from "react-icons/bs";
import { LiaUserEditSolid } from "react-icons/lia";
import { CiStar } from "react-icons/ci";
import { AiFillStar, AiOutlineStar } from 'react-icons/ai';

export const PiCardFillsIcon = PiCardsFill as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const SpadesIcon = ImSpades as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CloverIcon = FaClover as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const DiamondIcon = FaDiamond as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const LikeIcon = BiLike as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const ChatBubbleIcon = HiOutlineChatBubbleLeftRight as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const ThreeDotVerticalIcon = BsThreeDotsVertical as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const UserEditIcon = LiaUserEditSolid as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const StarIcon = CiStar as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const AiFillStarIcon = AiFillStar as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const AiOutlineStarIcon = AiOutlineStar as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
